import React from 'react';
import {useDownloadURL} from "react-firebase-hooks/storage";
import {firebaseStorage, storageRef} from "../../../firebase/client-app";

const QuoteTemplateImage = ({quoteTemplate, selectedQuoteTemplate, setSelectedQuoteTemplate}) => {
    const [value, loading, error] = useDownloadURL(storageRef(firebaseStorage, quoteTemplate?.imageDetail?.fullPath));

    let modes = {
        'fill': 'cover',
        'fit': 'contain'
    };
    let size = modes['fit'] || 'contain';

    let defaults = {
        height: 200,
        width: 200,
        backgroundColor: 'bg-purple-400',
    };


    return (
        <>
            {!loading && value &&
                <div className={`hover:bg-neutral-300 rounded m-1 cursor-pointer p-2
                ${selectedQuoteTemplate?.id === quoteTemplate?.id ? 'border-purple-400 border-2 shadow-xl bg-purple-200' : 'bg-white border-gray-200 border'}`}>
                    <div onClick={() => {
                        setSelectedQuoteTemplate(quoteTemplate);
                    }}
                         style={{
                             ...defaults, backgroundSize: size,
                             backgroundPosition: 'center center',
                             backgroundRepeat: 'no-repeat',
                             backgroundImage: `url("${value}")`
                         }}/>
                </div>
            }

            {loading && !value &&
                <div className="border-gray-200 bg-white hover:bg-neutral-400 border rounded m-1 cursor-pointer p-2">
                    <div style={{
                        ...defaults, backgroundSize: size,
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                    }}/>
                </div>
            }

        </>
    )
}

export default QuoteTemplateImage
